"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _configProvider = require("../config-provider/configProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Circle(props) {
  var style = props.style,
    _props$strokeWidth = props.strokeWidth,
    strokeWidth = _props$strokeWidth === void 0 ? 1.5 : _props$strokeWidth,
    _props$width = props.width,
    width = _props$width === void 0 ? 20 : _props$width;
  var getArcLength = function getArcLength(percent, radius) {
    return percent * 2 * radius * Math.PI;
  };
  var viewBox = function viewBox() {
    return "0 0 ".concat(width, " ").concat(width);
  };
  var cx = function cx() {
    return width / 2;
  };
  var cr = function cr() {
    return (width - strokeWidth) / 2;
  };
  var diameter = getArcLength(1, cr());
  var scalePathTimer = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)({
      transitionDuration: '0ms',
      strokeDasharray: "3 ".concat(diameter),
      strokeDashoffset: '0'
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pathStyle = _useState2[0],
    setPathStyle = _useState2[1];
  var scalePath = function scalePath(step) {
    step %= 3;
    switch (step) {
      case 0:
        setPathStyle({
          transitionDuration: '0ms',
          strokeDasharray: "3 ".concat(diameter),
          strokeDashoffset: '0'
        });
        break;
      case 1:
        setPathStyle({
          transitionDuration: '700ms',
          strokeDasharray: "".concat(0.7 * diameter, " ").concat(diameter),
          strokeDashoffset: -0.3 * diameter
        });
        break;
      case 2:
        setPathStyle({
          transitionDuration: '700ms',
          // 多出100ms用于显示最后一点
          strokeDasharray: "".concat(0.7 * diameter, " ").concat(diameter),
          strokeDashoffset: 3 - diameter
        });
        break;
    }
    scalePathTimer.current = setTimeout(function () {
      scalePath(step + 1);
    }, step ? 700 : 100);
  };
  (0, _react.useEffect)(function () {
    scalePath(0);
    return function () {
      if (scalePathTimer.current) {
        clearTimeout(scalePathTimer.current);
        scalePathTimer.current = null;
      }
    };
  }, []);
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var PREFIXCLS = getPrefixCls('loading');
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "".concat(PREFIXCLS, "-circle"),
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: "".concat(width, "px"),
      height: "".concat(width, "px")
    }),
    viewBox: viewBox()
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "".concat(PREFIXCLS, "-circle-path"),
    style: pathStyle,
    cx: cx(),
    cy: cx(),
    r: cr(),
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: strokeWidth,
    stroke: "currentColor"
  }));
}
Circle.propTypes = {
  width: _propTypes.default.number,
  strokeWidth: _propTypes.default.number
};
var _default = exports.default = Circle;